import $ from "jquery";
import {
  EldmlTransform,
  getDefaultButtonClassName,
  getThemeButtonClassName,
} from "./EldmlTransform";

interface ActionParam {
  key?: string;
  value?: string;
  type?: string;
}

export function transformActionbuttonElement(element: Element) {
  const button = $(element);
  const div = $("<div></div>");
  div.addClass("action-button");
  if (button.children().not("argument").length) {
    div.append(button.children().not("argument"));
  } else {
    let style = "";
    let themeClass;
    const bgColor = button.attr("bgcolor");
    const color = button.attr("color");
    if (bgColor) {
      style += `background: ${bgColor};`;
      div.addClass("white-color");
      themeClass = getDefaultButtonClassName();
    } else {
      const theme = button.attr("theme");
      themeClass = getThemeButtonClassName(theme);
    }

    if (color) {
      style += `color: ${color};`;
    }

    let width = button.attr("width");
    if (width) {
      width = width + "";
      width = width.endsWith("%") ? width : `${width}px`;
      style += `width: ${width};`;
    }

    const height = Number(button.attr("height"));
    if (height) {
      style += `height: ${height}px; line-height: ${height}px;`;
      let fontSize = 10;
      if (height > 30) {
        fontSize = height * 0.3;
      }
      style += `font-size: ${fontSize}px;`;
    }

    div.attr("style", style);
    div.addClass(themeClass);
    div.text(button.text());
  }
  const params = button.children("argument");
  const paramsArray: ActionParam[] = [];
  params.each((_, par) => {
    const param = $(par);
    if (param.attr("name") && param.attr("value")) {
      const paramObj: ActionParam = {};
      paramObj.key = param.attr("name");
      paramObj.value = param.attr("value");
      const type = param.attr("type")?.toUpperCase() ?? "TEXT";
      paramObj.type = ["TEXT", "INTEGER", "DOUBLE", "BOOLEAN"].includes(type)
        ? type
        : "TEXT";
      paramsArray.push(paramObj);
    }
  });
  div.attr("data-params", JSON.stringify(paramsArray));

  const defId =
    button.attr("data-defid") ||
    button.closest("[data-defid]").attr("data-defid");
  if (defId) {
    div.attr("data-defid", defId);
  }

  const docId =
    button.attr("data-docid") || button.closest("[data-id]").attr("data-id");
  if (docId) {
    div.attr("data-docid", docId);
  }

  const action = button.attr("action");
  if (action) {
    div.attr("data-action", action);
  }

  button.replaceWith(div);
}

export class ActionButtonsTransform extends EldmlTransform {
  apply() {
    this.selector.find("actionbutton").each((_, element) => {
      transformActionbuttonElement(element);
    });

    this.selector
      .off("click.action")
      .on("click.action", "div.action-button", (e) => {
        const div = $(e.currentTarget);
        e.stopPropagation();
        const actionCode = div.attr("data-action");
        if (actionCode) {
          const defId = div.attr("data-defid");
          const docId = div.attr("data-docid");
          const params = div.attr("data-params");
          this.transformer.executeAction(
              e.currentTarget,
              actionCode,
              defId,
              docId,
              params,
          );
        }

        return false;
      });
  }
}
